// extracted by mini-css-extract-plugin
export default {"wrapper":"MFKpgLYa","container":"XBTAklen","banner":"u4ihue_3","defaultPlaceholder":"NzDqeGqb","desktop":"desktop","pop-up_main_container":"pop-up_main_container","mobile":"mobile"};